var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "trans-fillin trans-edit"
  }, [_vm._m(0), _vm._v(" "), (_vm.showBank) ? _c('div', {
    staticClass: "row",
    on: {
      "click": _vm.onFocus
    }
  }, [_c('div', [_c('mt-field', {
    attrs: {
      "label": "转出银行名称",
      "placeholder": "请输入您转出银行的名称，例如“建设银行”",
      "type": "text"
    },
    model: {
      value: (_vm.trade.bank_name),
      callback: function($$v) {
        _vm.trade.bank_name = $$v
      },
      expression: "trade.bank_name"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.showBank) ? _c('div', {
    staticClass: "row",
    on: {
      "click": _vm.onFocus
    }
  }, [_c('div', [_c('mt-field', {
    attrs: {
      "label": "付款人姓名",
      "placeholder": "请输入您转出银行的户名，例如“张三”",
      "type": "text"
    },
    model: {
      value: (_vm.trade.bank_account_name),
      callback: function($$v) {
        _vm.trade.bank_account_name = $$v
      },
      expression: "trade.bank_account_name"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.showTradeNo) ? _c('div', {
    staticClass: "row",
    on: {
      "click": _vm.onFocus
    }
  }, [_c('div', [_c('mt-field', {
    attrs: {
      "label": _vm.lblTradeNo,
      "placeholder": _vm.plTradeNo,
      "type": "tel",
      "attr": _vm.attr
    },
    model: {
      value: (_vm.trade.trade_no),
      callback: function($$v) {
        _vm.trade.trade_no = $$v
      },
      expression: "trade.trade_no"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.showAlipayId) ? _c('div', {
    staticClass: "row",
    on: {
      "click": _vm.onFocus
    }
  }, [_c('div', [_c('mt-field', {
    attrs: {
      "label": "付款人姓名",
      "placeholder": "请输入您的真实姓名",
      "type": "text"
    },
    model: {
      value: (_vm.trade.alipay_id),
      callback: function($$v) {
        _vm.trade.alipay_id = $$v
      },
      expression: "trade.alipay_id"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row",
    on: {
      "click": _vm.onFocus
    }
  }, [_c('div', [_c('mt-field', {
    attrs: {
      "label": "支付金额",
      "placeholder": "请输入您的支付金额",
      "type": "tel",
      "attr": _vm.attr,
      "disableClear": ""
    },
    model: {
      value: (_vm.trade.amount),
      callback: function($$v) {
        _vm.trade.amount = $$v
      },
      expression: "trade.amount"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row",
    on: {
      "click": _vm.onPaidTimeClick
    }
  }, [_c('div', [_c('mt-field', {
    attrs: {
      "label": "支付日期",
      "placeholder": "请输入您的支付日期",
      "type": "text",
      "readonly": ""
    },
    model: {
      value: (_vm.trade.paid_time),
      callback: function($$v) {
        _vm.trade.paid_time = $$v
      },
      expression: "trade.paid_time"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "actions mt-50"
  }, [_c('mt-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmitClick
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onDelClick
    }
  }, [_vm._v("删除")])], 1)]), _vm._v(" "), _c('mt-datetime-picker', {
    ref: "picker",
    attrs: {
      "type": "datetime",
      "startDate": _vm.startDate,
      "endDate": _vm.endDate
    },
    on: {
      "confirm": _vm.handleConfirm
    },
    model: {
      value: (_vm.pickerValue),
      callback: function($$v) {
        _vm.pickerValue = $$v
      },
      expression: "pickerValue"
    }
  })], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-header"
  }, [_c('p', [_vm._v("为了顺利开通微信服务, 请如实填写如下查账信息")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.0.2@vue-loader/lib/template-compiler?{"id":"data-v-01b61f56","hasScoped":true}!./~/_vue-loader@13.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/payment/TransEdit.vue
// module id = 225
// module chunks = 0